import type { OsasResendPatientInviteCustomControlData } from '@common/validation/customControls/osas/osasResendPatientInviteSchema';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';

export function OsasResendPatientInviteRead() {
    const translate = getSelectedLanguage();
    const { processActivity } = useProcessActivityReadContext<OsasResendPatientInviteCustomControlData>();
    const { customControlData } = processActivity;

    return (
        <FormParagraphFormGroup label={translate.common.email}>
            {customControlData.patient.emailAddress}
        </FormParagraphFormGroup>
    );
}
